import { render, staticRenderFns } from "./freeze-info.vue?vue&type=template&id=e706a782&scoped=true&"
import script from "./freeze-info.vue?vue&type=script&lang=js&"
export * from "./freeze-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e706a782",
  null
  
)

export default component.exports